import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faFileInvoice, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { GetFacturasProformaByFiltersDtoProps } from "api/DTOs/GetFacturasProformaByFiltersDto"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { frontendDateFormat } from "utils/formatDate"

export const FACTURAS_PROFORMA_COLUMNS_ERP = (
  t: TFunction,
  convertirAfactura: (id?: string) => Promise<void>,
  setShowDeleteModal: Dispatch<
    SetStateAction<{
      show: boolean
      id: string | undefined
    }>
  >
) => [
  {
    header: t("nsProformaInvoices.table.columns.issueDate"),
    field: "fechaEmision",
    key: "fechaEmision",
    body: ({ fechaEmision }: GetFacturasProformaByFiltersDtoProps) =>
      fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "",
    style: { width: "10%" },
    sortable: true,
    className: "!tw-text-start",
    bodyClassName: "!tw-text-start",
    sortField: "fechaEmision",
  },
  {
    header: t("nsProformaInvoices.table.columns.number"),
    field: "numero",
    key: "numero",
    style: { width: "15%" },
    sortable: true,
    sortField: "NumeroDocumento",
  },

  {
    header: t("nsProformaInvoices.table.columns.client"),
    key: "cliente",
    field: "cliente",
    body: ({ cliente }: GetFacturasProformaByFiltersDtoProps) => {
      return `${cliente?.razonSocial} (${cliente?.nif})`
    },
    sortable: true,
    sortField: "Cliente.Empresa.RazonSocial",
  },
  {
    header: t("nsProformaInvoices.table.columns.linkedInvoice"),
    field: "factura",
    key: "factura",
    body: ({ factura }: GetFacturasProformaByFiltersDtoProps) => {
      return `${factura?.numero ?? "-"}`
    },
    style: { width: "10%" },
  },
  {
    header: t("nsProformaInvoices.table.columns.amount"),
    field: "importe",
    key: "importe",
    bodyClassName: "!tw-text-end",
    alignCol: "right",
    style: { width: "11%" },
    body: ({ importe }: GetFacturasProformaByFiltersDtoProps) =>
      formatCurrency(importe),
    sortable: true,
    sortField: "importe",
  },
  {
    key: "opciones",
    style: { width: "4%" },
    className: "!tw-p-2",
    bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
    alignCol: "right",
    body: (rowData: GetFacturasProformaByFiltersDtoProps) => {
      if (!rowData.id) return null

      return (
        <OptionsMenuStorybook
          id={rowData.id}
          disabled={!!rowData?.factura}
          items={[
            {
              title: `${t("nsProformaInvoices.table.columns.convertToBill")}`,
              hasRedirect: true,
              action: () => {
                return convertirAfactura(rowData.id)
              },
              icon: faFileInvoice,
            },
            {
              title: `${t("nsProformaInvoices.table.columns.delete")}`,
              hasRedirect: false,
              action: () => setShowDeleteModal({ show: true, id: rowData.id }),
              icon: faTrashCan,
              className: "tw-text-danger",
              iconClassName: "tw-text-danger",
            },
          ]}
          position='right'
        />
      )
    },
  },
]
